import React, { Component, useState } from 'react';
import { FormattedMessageWrappedInSpan } from '../../../components/misc';



const JobHiwiNetwork = ({setShowJob, showJob, job, ...props}) => {

  return (
    <>
    { job == "hiwiNetwork" &&
    <div className="container-960 container-page">
      <h2>
        <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.headline" defaultMessage="Placeholder" />
      </h2>
      <br />
      <br />
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.aboutus.title" defaultMessage="Placeholder" />
      </b>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.hiwiNetwork.aboutus.text"
          defaultMessage="Placeholder"
          values={{
            br: <br />,
          }}
        />
      </p>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.yourroll.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.yourroll.bullet1" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.yourroll.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.yourroll.bullet3" defaultMessage="Placeholder" />
          </li>
        </ul>
      </span>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.needs.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.needs.bullet1" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.needs.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.needs.bullet3" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.needs.bullet4" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.needs.bullet5" defaultMessage="Placeholder" />
          </li>
        </ul>
      </span>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.offer.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.offer.bullet1" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.offer.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.offer.bullet3" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.offer.bullet4" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.offer.bullet5" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.offer.bullet6" defaultMessage="Placeholder" />
          </li>
        </ul>
      </span>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.hiwiNetwork.contact.title" defaultMessage="Placeholder" />
      </b>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.hiwiNetwork.contact.contact"
          defaultMessage="Placeholder"
        />
      </p>
      <br />
      <button className="secondary" onClick={() => setShowJob(!showJob)}>
        <FormattedMessageWrappedInSpan
          id="jobsPage.back"
          defaultMessage="back"
        />
      </button>
      </div>
            }
      </>
  )
}

export default JobHiwiNetwork
